export interface LivestreamConfigurationResponse {
    id: number;
    user_id: number;
    entry: string;
    entry_id: number;
    provider: string;
    stream_id: string;
    status: string;
    last_checked_at?: any;
    created_at: Date;
    updated_at: Date;
}

export interface EntryIdentifier {
    entry: string;
    entry_id: string;
}

export class LivestreamConfigurationService {
    static $inject = ['$http'];

    constructor(private $http: ng.IHttpService) {}

    protected getLocalStorageKey({ entry_id, entry }: EntryIdentifier) {
        return `livestreaming_configuration:${entry}:${entry_id}`;
    }

    protected saveLocalConfiguration(entryIdentifier: EntryIdentifier, streamKey: string) {
        return localStorage.setItem(this.getLocalStorageKey(entryIdentifier), streamKey);
    }

    protected getLocalConfiguration(entryIdentifier: EntryIdentifier): string {
        return localStorage.getItem(this.getLocalStorageKey(entryIdentifier)) || '';
    }

    public store(entryIdentifier: EntryIdentifier, payload: { streamId: string; streamKey: string }) {
        const { entry, entry_id } = entryIdentifier;
        const { streamKey, streamId } = payload;

        this.saveLocalConfiguration(entryIdentifier, streamKey);

        return this.$http.post<LivestreamConfigurationResponse>('/api/v1.0/livestreaming/configuration', {
            entry,
            entry_id,
            stream_id: streamId,
        });
    }

    public get(entry: EntryIdentifier) {
        return this.$http
            .get<LivestreamConfigurationResponse>('/api/v1.0/livestreaming/configuration', { params: entry })
            .then((v) => ({
                ...v.data,
                streamKey: this.getLocalConfiguration(entry),
            }));
    }

    public getStreamingKey(entry: EntryIdentifier): string | undefined {
        return this.getLocalConfiguration(entry);
    }
}

angular.module('tradersyard').service('LivestreamConfigurationService', LivestreamConfigurationService);
